import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Box, Grid, Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import RoomIcon from '@material-ui/icons/Room';
import MailIcon from '@material-ui/icons/Mail';
import PrintIcon from '@material-ui/icons/Print';
import PhoneIcon from '@material-ui/icons/Phone';
import { useStyles } from './styles';
import { useSelector } from 'react-redux';
import { getPointPrivateLabel } from '../../helpers';
import { insertActivityLog } from '../../actions';
import { getAppSource, getUserType } from '../../helpers';
import ticket from '../../assets/SupportTicket/ticket.svg';
import Cookies from 'js-cookie';

export function ReactOutToUs(props) {
  const mytheme = useSelector(state => state.theme);
  const classes = useStyles();
  const { privateLabelCode, privateLabelName, address, customerCareNumber, lendingNumber, customerCareTime, lendingNumberTime } = mytheme;
  const loanInfo = useSelector(state => state?.loanInfoReducer);
 
  useEffect(() => {
    if (props?.contactUs) {
      setTimeout(() => {
        window.scrollTo({ top: getPointPrivateLabel() ? 250 : 450, left: 0, behavior: 'smooth' });
      }, 1000);
   }
  }, [props?.contactUs])

  const sendActivityData = async (message) => {
    const remark = message;
    const data = {
      "accountNumber": Cookies.get("selectedAccount"),
      "activityCode": "UAL205",
      "activityStatus": "Success",
      "action": "SupportHelp",
      "controller": "SupportTicket",
      "apiName": "SupportTicket",
      "activityRemark":  remark,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": "",
    };

    await insertActivityLog(data);
  }

  const five9Status = () => {
    if ((loanInfo.isFive9 && Cookies.get('privateToken')) || !Cookies.get('privateToken')) {
      return true
    } else {
      return false
    }
  }

  return (
    <div className={classes.bg}>
      <Typography className={classes.mainHeading}
        variant="h4" component="h4" >
        Have questions? Let us help you</Typography>

      <Box className={classes.root} >
        <Paper className={classes.paper} my={5} style={{ width: '100%' }}>
          <Grid container display="flex" justifyContent="space-around"  style={{ height: '100%' }}>
            <Box className={classes.flexItem}>
              <Box className={`${classes.helpAddress} ${classes.flex}`} >
                <RoomIcon className={classes.iconStyle} />
                <Box>

                  {privateLabelCode === 'BSI021' ? <Box dangerouslySetInnerHTML={{ __html: address }}></Box> :
                    <><p className={classes.bodyText}>{privateLabelName}</p>
                      <p>P.O. Box 517<br />Titusville, PA 16354-0517</p></>}
                </Box>
              </Box>
            </Box>
            <Box className={`${classes.flexItem} ${classes.noborder}`}>
             {loanInfo.isSupportTicket && <> <Box className={`${classes.helpAddress} ${classes.flex}`} style={{paddingTop: '12%'}} onClick={() => sendActivityData("Support Ticket - Clicked on help page hyperlink")}>
                <img src={ticket} className={classes.iconStyle} />
                <Box>
                  <Box component="span" >
                    <Link className={classes.linkStyle} to='/SupportTicket'>Create Ticket </Link></Box>
                </Box>
              </Box>
              </>}
              { five9Status() && <>
              { loanInfo.isSupportTicket && <Box className={classes.separate}/>}
              <Box className={`${classes.helpAddress} ${classes.flex}`}>
                <MailIcon className={classes.iconStyle} />
                <Box>
                  <Box component="span" >
                    <Link className={classes.linkStyle} to='/ContactUs'>Email us </Link></Box>
                </Box>
              </Box> </>}
            </Box>
              
            <Box className={classes.flexItem} >
              { customerCareNumber &&
              <Box>
                <Box className={`${classes.helpAddress} ${classes.flex}`}>
                  <Box style={{display: 'flex', alignItems: 'center'}}>Customer Care: <PhoneIcon mr={2} className={classes.icon} />
                   <a href={"tel:" + customerCareNumber} style={{textDecoration: 'none', cursor: 'pointer', color: '#4D4D4D'}}>
                    <span className={`${classes.contactTime} ${classes.noUnderLine}`} >
                    {customerCareNumber}</span></a>
                  </Box>
                </Box> 
                <Typography className={classes.visitTimeFont} mt={2} dangerouslySetInnerHTML={{ __html: customerCareTime }}></Typography>
              </Box> }
              { lendingNumber &&
              <Box mt={1}  className={classes.separate}>
                <Box mt={1}>
                  <Box className={`${classes.helpAddress} ${classes.flex}`}>
                    <Box style={{display: 'flex', alignItems: 'center'}}>Buy / Refinance: <PhoneIcon mr={2} className={classes.icon} />
                       <a href={"tel:" + lendingNumber} style={{textDecoration: 'none', cursor: 'pointer', color: '#4D4D4D'}}>
                       <span className={`${classes.contactTime} ${classes.noUnderLine}`} >
                      {lendingNumber}</span></a>
                    </Box>
                  </Box> 
                  <Typography className={classes.visitTimeFont} mt={2} dangerouslySetInnerHTML={{ __html: lendingNumberTime }}>
                  </Typography>
                </Box>  
              </Box> }
           </Box>

          </Grid>
        </Paper>
      </Box>
    </div>
  );
}
